var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMomoActive = function SvgMomoActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5,
    d: "M4.75 10.5a.75.75 0 0 1 .75-.75h25.8a.75.75 0 0 1 .75.75v15.9a.75.75 0 0 1-.75.75H5.5a.75.75 0 0 1-.75-.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AF016C",
    stroke: "#AF016C",
    strokeLinejoin: "bevel",
    strokeWidth: 0.2,
    d: "M6.35 10.25a1.1 1.1 0 0 0-1.1 1.1v14.2a1.1 1.1 0 0 0 1.1 1.1h24.1a1.1 1.1 0 0 0 1.1-1.1v-14.2a1.1 1.1 0 0 0-1.1-1.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.003 21.307v3.009h1.64v-3.01c0-.538.102-1.093.767-1.093.875 0 .875.74.875 1.094v3.009h1.97v-3.01c0-.6.122-1.093.765-1.093s.808.413.808 1.094v3.009h1.6v-3.01c0-1.481-.903-2.406-2.408-2.406-.963 0-1.604.401-1.805.602-.2-.2-.842-.602-1.805-.602-1.505 0-2.468 1.203-2.407 2.407"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.992 24.316a2.708 2.708 0 1 0 0-5.416 2.708 2.708 0 0 0 0 5.416m0-1.354a1.354 1.354 0 1 0 0-2.708 1.354 1.354 0 0 0 0 2.708",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.003 14.407v3.009h1.64v-3.009c0-.539.102-1.094.767-1.094.875 0 .875.74.875 1.094v3.009h1.97v-3.009c0-.602.122-1.094.765-1.094s.808.413.808 1.094v3.009h1.6v-3.009c0-1.482-.903-2.407-2.408-2.407-.963 0-1.604.401-1.805.602-.2-.2-.842-.602-1.805-.602-1.505 0-2.468 1.204-2.407 2.407"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.992 17.416a2.708 2.708 0 1 0 0-5.416 2.708 2.708 0 0 0 0 5.416m0-1.354a1.354 1.354 0 1 0 0-2.708 1.354 1.354 0 0 0 0 2.708",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 9h2.5v1H12zM24.5 27H27v1h-2.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 9.5,
    r: 0.5,
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.5 27.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M12.5 9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M25 27.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
  })));
};
export default SvgMomoActive;